import React,{useRef} from "react";

const BattingIframe = ({ detail }) => {
  const iframeRef = useRef(null);
  const ref = useRef(null);


  const handleIframeLoad = () => {
    const handleMessage = (event) => {
      // security check
      if (event.origin !== "https://scorecard.oddstrad.com") return;

      const data = event.data;
      console.log("data", data);

      // resize event
      if (data.height && iframeRef.current) {
        iframeRef.current.style.height = data.height + "px";
      }

      // custom click event
      if (data.type === "FOOTER_CLICKED") {
        console.log("Footer clicked inside iframe", data);
      }
    };

    window.addEventListener("message", handleMessage);
  };
  console.log(detail?.eventType,detail?.eventId,detail?.scoreId);
  return (
     <iframe
      ref={iframeRef}
      id="scoreFrame"
      scrolling="no"
      sandbox="allow-scripts allow-same-origin"
      referrerPolicy="strict-origin-when-cross-origin"
      className="responsive-iframe w-100"
      style={{
        overflow: "hidden",
        height: detail?.screenScore === "full" ? "270px" : "177px",
        backgroundColor: "#000",
        zIndex: 99
      }}
      onLoad={handleIframeLoad}
      src={`https://scorecard.oddstrad.com/get-scorecard-iframe/${detail?.eventType}/${detail?.eventId}/${detail?.scoreId}`}
    />
  );
};

export default BattingIframe;
